"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GradeTypeConstants = _interopRequireDefault(require("../constants/GradeTypeConstants"));

var _ScoreConstants = _interopRequireDefault(require("../constants/ScoreConstants"));

var _default = {
  getOverallGradeType: function getOverallGradeType(grade) {
    if (grade >= _ScoreConstants.default.GREAT_THRESHOLD) {
      return _GradeTypeConstants.default.GREAT;
    } else if (grade >= _ScoreConstants.default.GOOD_THRESHOLD) {
      return _GradeTypeConstants.default.GOOD;
    } else if (grade >= _ScoreConstants.default.OK_THRESHOLD) {
      return _GradeTypeConstants.default.OK;
    } else {
      return _GradeTypeConstants.default.BAD;
    }
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/util/ScoreUtil.js
// module id = 154
// module chunks = 0